import { z } from 'zod';

const uuidRegex = new RegExp(
  /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/,
);

export const CategoryNameType = z
  .string()
  .trim()
  .refine((s) => !uuidRegex.test(s), {
    message: 'Category name cannot be uuid',
  });

export const CreateCategoryBody = z.object({
  name: CategoryNameType,
});

export const UpdateCategoryBody = z.object({
  name: CategoryNameType,
  hidden: z.boolean().optional(),
});
